enum DeviceTypeEnum {
  SMART_LOCK_UNKNOWN = 'SL_UNKNOWN',

  BOX = 'BX',
  OPENER = 'OP',
  SMART_DOOR = 'SD',

  SMART_LOCK_1_OR_2 = 'SL',

  SMART_LOCK_3_UNKNOWN = 'SL3', // without 'UNKNOWN' keyword in value for legacy support
  SMART_LOCK_3_BASIC = 'SL3_BASIC',
  SMART_LOCK_3_PRO = 'SL3_PRO',

  SMART_LOCK_4G_UNKNOWN = 'SL4G',
  SMART_LOCK_4G_BASIC = 'SL4G_BASIC',
  SMART_LOCK_4G_PRO = 'SL4G_PRO',

  SMART_LOCK_5G_UNKNOWN = 'SL5',
  SMART_LOCK_5G_GO = 'SL5G_GO',
  SMART_LOCK_5G_PRO = 'SL5G_PRO',
  SMART_LOCK_5G_ULTRA = 'SL5G_ULTRA',

  VIRTUAL_SMART_LOCK = 'VSL',
  BRIDGE = 'BR',
  BRIDGE_2 = 'BR2',
  FOB = 'FB',
  DOOR_SENSOR = 'DS',

  KEYPAD = 'KP',
  KEYPAD_1 = 'KP1',
  KEYPAD_2 = 'KP2',
  KEYPAD_2_PRO = 'KP2_PRO',
}

export default DeviceTypeEnum;
